import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"
import { useAuthSession } from "~/hooks/useAuthSession"

const SignoutPage = () => {
  const { signOut } = useAuthSession()

  useEffect(() => {
    void signOut({ callbackUrl: "/" })
  }, [signOut])

  return <></>
}

function AuthSignoutPageWrapper() {
  return <SignoutPage />
}

export const Route = createFileRoute("/auth/signout")({
  component: AuthSignoutPageWrapper,
})
